<template>
  <section>
    <Title
      v-if="title.PhotoPayMealPlan"
      :title-name="title.PhotoPayMealPlan.titleName"
      :title-link="title.PhotoPayMealPlan.titleLink"
    />
    <div v-if="pax && !expireMealPlanTime" class="photo-pay-container">
      <div v-if="lang && lang.meal_plan_photo_claim_new" id="photo-pay" class="photo-pay container pt-4">
        <div>
          <div class="title-voucher refreshment-voucher mb-3">
            <ItemOfVouchers
              icon="meal-plan-voucher"
              color="#f5b945"
              :label="lang['meal_plan_photo_claim_new']?.SFS_LANG_ROW_38 || 'Meal Plan voucher'"
              border
            />
          </div>
          <div class="photo2claim">
            <PhotoPayStep
              v-if="step == 1"
              :secret="secret"
              :meal-plan-info="MealPlanInfoPax"
              :meal-plan-price-total-pax="MealPlanPriceTotalPax"
              :is-name-null="isNameNull"
              @nextStep="nextStep"
              @updateIsNameNull="updateIsNameNull"
            />
          </div>
        </div>
        <PhotoPayInfo
          v-if="step == 2"
          :secret="secret"
          :meal-plan-info="MealPlanInfoPax"
          :meal-plan-price-total-pax="MealPlanPriceTotalPax"
        />
      </div>
    </div>
    <div v-else-if="pax && expireMealPlanTime">
      <div class="container">
        <div v-if="lang.expire_link" class="mt-3">
          <p>{{ lang.expire_link.SFS_LANG_ROW_4 }}</p>
        </div>
      </div>
    </div>
    <b-alert
      v-model="showAlertTop"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000; border-radius: 1rem !important; border: 1px solid #ffa5a5; color: #444"
      variant="danger"
      dismissible
    >
      <div v-for="(error, index) in messagesError" :key="index">
        <div>{{ error }}</div>
      </div>
    </b-alert>
  </section>
</template>
<script>
import '@/assets/scss/modules/PhotoPay.scss'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'
import Title from '@/components/Title/index'
import PhotoPayStep from './PhotoPayStep'
import PhotoPayInfo from './PhotoPayInfo'
import { mapGetters } from 'vuex'

export default {
  name: 'MealPlanPhotoPay',
  components: { ItemOfVouchers, Title, PhotoPayStep, PhotoPayInfo },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      step: 1,
      MealPlanInfoPax: {},
      service: {},
      isNameNull: false,
      messagesError: [],
      showAlertTop: false,
      expireMealPlanTime: false
    }
  },
  computed: {
    ...mapGetters({
      MealPlanInfo: 'MealPlan/MealPlanInfoPax',
      MealPlanPriceTotalPax: 'MealPlan/MealPlanPriceTotalPax',
      Services: 'Home/Services',
      dataInfoBankPax: 'Refreshment/dataInfoBankPax'
    })
  },
  watch: {
    MealPlanInfo: {
      handler() {
        this.checkStep()
      },
      deep: true
    },
    Services: {
      handler() {
        this.checkStep()
      },
      deep: true
    },
    airline: function () {
      if (this.airline.meal_enabled != '2') {
        let secret = this.$route.query.secret
        this.$router.push({ path: '/home', query: { secret: secret } })
      }
    },
    showAlertTop() {
      if (this.showAlertTop) {
        setTimeout(() => {
          this.showAlertTop = false
        }, 5000)
      }
    }
  },
  created() {
    if (!this.$route.query.voucher_code) {
      this.$router.push({ path: '/home', query: { secret: this.$route.query.secret } })
      return
    }

    let mealplan_time = this.$route.query.mealplan_time
    let airportTime = new Date()
    let is_used = this.$route.query.is_used
    this.$store
      .dispatch('MealPlan/getMealPlanByVoucherCode', {
        secret: this.secret,
        voucher_code: this.$route.query.voucher_code
      })
      .then((response) => {
        if (response.length > 0) {
          mealplan_time = response[0].mealplan_expired
          airportTime = response[0].currentTime
          is_used = response[0].is_used
        }
        this.checkExpireTimeMealPlan(mealplan_time, airportTime, is_used)
      })
      .catch((e) => {
        this.checkExpireTimeMealPlan(mealplan_time, airportTime, is_used)
      })

    // this.$store.dispatch('Refreshment/getInfoRef', this.$route.query.refreshmentId)
    // this.$store
    //   .dispatch('Refreshment/getPriceRef', this.$route.query.refreshmentId)
    //   .then((response) => {
    //     if (!response.length) {
    //       this.$router.push({ path: '/home', query: { secret: this.$route.query.secret } })
    //     }
    //   })
    //   .catch((e) => {
    //     this.$router.push({ path: '/home', query: { secret: this.$route.query.secret } })
    //   })
    this.$store.dispatch('Home/getServices')
  },
  mounted() {
    this.checkStep()
  },
  methods: {
    updateIsNameNull(value) {
      this.isNameNull = value
      if (this.isNameNull) {
        this.showAlertTop = true
        this.messagesError.push('Enter an account holder name')
      } else {
        this.showAlertTop = false
      }
    },
    nextStep(data) {
      this.step = data
    },
    checkStep() {
      if (this.Services.length == 0) {
        this.$store.dispatch('Home/getServices')
      }
      this.service = _.find(this.Services, { service_id: 23 })
      if (!this.service) {
        return false
      }

      if (this.MealPlanInfo && this.MealPlanInfo.bank_info) {
        this.MealPlanInfoPax = this.MealPlanInfo
        if (this.MealPlanInfo.bank_info && !_.isEmpty(this.MealPlanInfo.bank_info.transfer_bank_info)) {
          this.step = 2
        } else {
          this.step = 1
        }
      } else {
        this.$store.dispatch('MealPlan/getInfoMealPlan', this.$route.query.voucher_code)
      }
    },
    checkExpireTimeMealPlan(mealPlanTime, airportTime, is_used) {
      let mealPlanParse = new Date(mealPlanTime)
      let dateNowMealPlan = new Date(airportTime)
      if (dateNowMealPlan.getTime() > mealPlanParse.getTime() && !is_used) {
        this.expireMealPlanTime = true
      }
    }
  }
}
</script>
